module.exports = __webpack_public_path__ + "img/bg.601e6bd2.png";